// Auto "Lite Graphics" mode.
//
// The Betohalics casino games layer a lot of ALWAYS-ON decorative GPU effects
// behind the reels (full-screen frosted-glass `backdrop-filter`, big blurred
// caustics layers, and dozens of infinite particle/ray animations). On phones,
// tablets and low-power machines those layers eat the frame budget every frame
// and make the reels stutter / feel choppy — even though the reel engine
// itself is well optimised.
//
// This detects weaker / touch devices and adds `perf-lite` to <html>. The
// paired stylesheet (perf-lite.css) then drops ONLY the decorative ambient
// layers + backdrop blur — never any reel or gameplay animation — so the reels
// get the whole GPU. Desktops with a mouse and healthy specs keep the full
// eye-candy.
export function applyPerfMode() {
  try {
    const nav = typeof navigator !== 'undefined' ? navigator : {};
    const mm = (q) => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false);

    const reduceMotion = mm('(prefers-reduced-motion: reduce)');
    const touch = mm('(pointer: coarse)');           // phones / tablets
    const lowMem = typeof nav.deviceMemory === 'number' && nav.deviceMemory <= 4;   // GB (Chrome)
    const lowCpu = typeof nav.hardwareConcurrency === 'number' && nav.hardwareConcurrency <= 4;

    const lite = reduceMotion || touch || lowMem || lowCpu;
    document.documentElement.classList.toggle('perf-lite', !!lite);
  } catch (_e) {
    // If anything about detection fails, leave the full effects on.
  }
}
